import { Icon } from 'components'
import styles from './Home.module.scss'
import { useTheme } from 'shared/hooks'

const Home = () => {
  const { theme } = useTheme()

  return (
    <div className={styles.homeWrapper}>
      <Icon
        name={theme === 'light' ? 'logo' : 'logo-white'}
        height={80}
        width={250}
      />
    </div>
  )
}

export default Home
